import { ColumnDef } from "@tanstack/react-table"
import { PlansQuery } from "~/__generated__/graphql"
import { Link } from "react-router-dom"
import { Button } from "~/ui/button"

type Plan = NonNullable<NonNullable<PlansQuery["plans"]["edges"][0]>["node"]>
type PlanTableData = Plan | null | undefined

export const columns: ColumnDef<PlanTableData>[] = [
  {
    accessorKey: "title",
    header: "Title",
    cell: ({ row }) => row.original?.title ?? "",
  },
  {
    accessorKey: "description",
    header: "Description",
    cell: ({ row }) => row.original?.description ?? "",
  },
  {
    accessorKey: "datetime",
    header: "Date & Time",
    cell: ({ row }) =>
      row.original?.datetime ? new Date(row.original.datetime).toLocaleString() : "",
  },
  {
    accessorKey: "minPeople",
    header: "Min People",
    cell: ({ row }) => row.original?.minPeople ?? "",
  },
  {
    accessorKey: "maxPeople",
    header: "Max People",
    cell: ({ row }) => row.original?.maxPeople ?? "",
  },
  {
    accessorKey: "location",
    header: "Location",
    cell: ({ row }) => row.original?.location.name ?? "",
  },
  {
    accessorKey: "createdAt",
    header: "Created",
    cell: ({ row }) =>
      row.original?.createdAt ? new Date(row.original.createdAt).toLocaleDateString() : "",
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) =>
      row.original && (
        <div className="flex gap-2">
          <Link to={`/plans/${row.original.id}`}>
            <Button variant="outline" size="sm">
              View
            </Button>
          </Link>
          <Link to={`/plans/${row.original.id}/edit`}>
            <Button variant="outline" size="sm">
              Edit
            </Button>
          </Link>
        </div>
      ),
  },
]
